var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGovernmentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.912,
    height: 33.912,
    viewBox: "0 0 33.912 33.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "government",
    transform: "translate(-0.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M0,300.6H13.249v-7.595h7.42V300.6H33.915V285.608H0Zm28.88-12.265h1.987v3.29H28.883Zm0,5.278h1.987v3.29H28.883Zm-4.107-5.278h1.987v3.29H24.776Zm0,5.278h1.987v3.29H24.776Zm-11.527-4.958h7.42v1.987h-7.42Zm-6.095-.32H9.142v3.29H7.155Zm0,5.278H9.142v3.29H7.155Zm-4.107-5.278H5.035v3.29H3.047Zm1.987,5.278v3.29H3.047v-3.29Z",
    transform: "translate(0 -266.688)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M229.959,427.274H233.4v5.607h-3.445Z",
    transform: "translate(-214.722 -398.969)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M69.959,205.6H94.6v3.313H69.959Z",
    transform: "translate(-65.322 -191.984)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M154.844,7.438h-.177v-1.7h4.574V0H152.68V7.438H152.5a6.524,6.524,0,0,0-6.086,4.2H160.93A6.524,6.524,0,0,0,154.844,7.438Z",
    transform: "translate(-136.715)",
    fill: "#7dbaab"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernmentIcon);
export default __webpack_public_path__ + "static/media/government-icon.7611d0442227bb9c6f0ad8a3742c94d8.svg";
export { ForwardRef as ReactComponent };